import React, { useState, useEffect } from "react";
import CompanySearch from "../../../../components/common/forms/CompanySearch";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormUploadDocument from "../../../../components/common/forms/FormUploadDocument";
import { SSF_upload_details_v2 } from "./SSFregistrationForm";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import Documents from "../../../../components/common/forms/Documents";
import FormPayment from "../../../../components/common/forms/FormPayment";
import api from "../../../../api/api";
import { toast } from 'react-toastify';
import SSFRegistrationB from "../SSFRegistrationB/SSFRegistrationB";
import BackButton from "../../../../components/common/backbutton/BackButton";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";
import { useSelector } from "react-redux";

const SSFRegistrationA = () => {
  const { register, handleSubmit } = useForm();

  // employee inital state
  // const initState = {
  //   id: uuidv4(),
  //   name: "",
  //   address: "",
  //   phone: "",
  //   photo: "",
  // };

  const [docsOutput, setDocsOutput] = useState([]);
  const [changeForm, setChangeForm] = useState(true)
  const [employee, setEmployee] = useState([
    {
      id: uuidv4(),
      name: "",
      address: "",
      phone: "",
      photo: "",
    },
    {
      id: uuidv4(),
      name: "",
      address: "",
      phone: "",
      photo: "",
    },
  ]);

  const [uploadProof, setUploadProof] = useState('')
  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)

  const [receivedAmount, setReceivedAmount] = useState({})
  const [dueAmount, setDueAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);



  // getting current user
  useEffect(() => {
    api
      .get("/users/me/")
      .then((response) => {
        setDueAmount(response.due_amount);
      })
      .catch((error) => { });
  }, []);



  useEffect(() => {
    api.get('/services/company/registration/service-charges/?company_type=ssf&ssf_form_type=employer')
      .then(response => {
        // console.log(response.data)
        setReceivedAmount(response.data[0])
      }).catch(error => {

      })
  }, []);


  const handleClick = (data) => {
    // data.share_holders = shareHolders
    data.documents = docsOutput;
    data.employees = employee;
    data.company_type = "ssf";
    // console.log(data);

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID
      }
    }
    // console.log(data);

    api
      .post("/services/company/", data)
      .then((response) => {
        // console.log(response.data)
        toast.success("Data Registered Successfully.");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof: uploadProof,
          company: response.data.company_id,
          transaction_type: "credit"

        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((error) => {
        // console.log(error)
        toast.error("Data Registered failed");
      });
  };

  let data = [];
  SSF_upload_details_v2.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  const handlePhoto = async (index, e) => {
    // if(e.target.name === "photo"){
    const newEmployee = [...employee];

    setEmployee(newEmployee);

    let reader = new FileReader();
    let baseURL = "";
    reader.readAsDataURL(e.target.files[0]);

    return new Promise((resolve) => {
      reader.onload = () => {
        baseURL = reader.result;
        newEmployee[index][e.target.name] = baseURL;
        resolve(baseURL);
      };
    });
    // }
  };

  const handleChange = (index, e) => {
    // for other target name
    const newEmployee = [...employee];
    newEmployee[index][e.target.name] = e.target.value;
    setEmployee(newEmployee);
  };
  const formChangeA = () => {
    setChangeForm(true)
  }
  const formChangeB = () => {
    setChangeForm(false)
  }
  return (
    <div className="px-10 lg:!px-14">
      <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
        SSF Registration
      </p>
      <div className=" w-full flex flex-wrap gap-5 text-center my-3 justify-center">
        <div onClick={formChangeA} className={` ${changeForm === true ? "bg-primary-blue  text-white" : "bg-gray-300"} px-3  py-2 cursor-pointer rounded-2xl font-bold`}>सामाजिक सुरक्षा कोषमा दर्ता</div>
        <div onClick={formChangeB} className={` ${changeForm === false ? "bg-primary-blue  text-white" : "bg-gray-300"} px-3  py-2 cursor-pointer rounded-2xl font-bold`}>सामाजिक सुरक्षा कोषमा कर्मचारी दर्ता</div>
      </div>


      {
        changeForm === true ? <>
          <form >
            <div className="mt-3">
              {

                (user?.user_type === "ST" || user?.user_type === "AD")
                && <AdminSearchCustomer
                  setUserId={setUserId}
                />
              }
            </div>

            <div className="flex justify-between">
              <p className="text-primary-blue font-Calistoga text-lg my-3 underline">
                1. Business Name & Other Details
              </p>


              <p className="text-primary-red flex">
                Firm No.
                <span className=" text-primary-blue"> 1234</span>
              </p>
            </div>
            <div className="flex md:flex-row flex-col  gap-5">
            <CompanySearch register={register} />
              <div className="font-Laila text-primary-blue border-2 w-[10rem] text-center border-primary-blue p-2">
              तपाईको कम्पनी सामाजिक सुरक्षा कोषमा दर्ता गर्दा लाग्ने जम्मा रकम रु. <span className="text-primary-red"> {parseInt(receivedAmount?.amount)}|- </span> मात्र |
              </div>
            </div>

            <div className="mt-5">

              <div className="">
                <div className="grid md:grid-cols-3 border-primary-blue border-2 w-full font-Laila grid-cols-1 ">
                  <div className="border-primary-blue text-primary-red  text-center md:border-r border-b p-3  text-lg font-bold">
                    कम्पनीको नाम
                  </div>

                  <div className="border-primary-blue font-Calistoga p-3 flex text-primary-red md:border-r border-b w-full text-base  sm:text-lg">
                    <p>Englishमा:</p>
                    {/* <input /> */}
                    <input
                      className="outline-none text-primary-blue pl-2"
                      {...register(`company_name`, {
                        // required: false,
                      })}
                    />
                  </div>
                  <div className="border-primary-blue flex text-primary-red md:border-b w-full text-base p-3 font-bold sm:text-lg">
                    <p>नेपालीमा:</p>
                    <input
                      className="outline-none text-primary-blue pl-2"
                      {...register(`company_name_nep`, {
                        // required: false,
                      })}
                    />
                  </div>


                  <div className="border-primary-blue text-primary-red  text-center md:border-r border-b p-3  text-lg font-bold">
                    कम्पनीको ठेगाना
                  </div>
                  <div className="border-primary-blue flex text-primary-red border-b md:border-r w-full text-base font-bold sm:text-lg">
                    <input
                      className="outline-none text-primary-blue pl-2"
                      {...register(`company_address`, {
                        // required: false,
                      })}
                    />
                  </div>
                  <div className="border-primary-blue p-3 flex text-primary-red w-full border-b md:border-r text-base font-Calistoga sm:text-lg">
                    <p>Email:</p>
                    <input
                      className="outline-none  text-primary-blue pl-2"
                      {...register(`company_email`, {
                        // required: false,
                      })}
                    />
                  </div>

                  <div className="border-primary-blue text-primary-red  text-center border-b md:border-r p-3  text-lg font-bold">
                    कम्पनी/ब्यवसायको उद्धेश्यहरु
                  </div>

                  <div className="border-primary-blue p-3 flex text-primary-red w-full border-b md:border-r text-base  font-bold sm:text-lg">

                    <input placeholder="मुख्य कामहरु" className="outline-none text-primary-blue pl-2" />
                  </div>
                  <div className="border-primary-blue font-Calistoga p-3 flex text-primary-red border-b  text-base font-bold sm:text-lg">
                    <p className="font-Calistoga">Ph.No.:</p>
                    <input
                      className="outline-none text-primary-blue pl-2"
                      {...register(`company_phone`, {
                        // required: false,
                      })}
                    />
                  </div>



                  <div
                    className="border-primary-blue text-primary-red md:border-r border-b md:border-b-0 p-3 text-center text-lg font-bold">
                    ब्यवसायको प्रकार
                  </div>

                  <div className="border-primary-blue  gap-1 flex text-primary-red p-3 md:border-b-0 border-b md:flex-row flex-col md:border-r text-base font-bold sm:text-sm">
                    <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full  px-1 py-0 text-white">
                      <label htmlFor="ekal" className="text-sm">एकल ब्यवसाय </label>
                      <input
                        type="radio"
                        name="radio-btn"
                        id="ekal"
                        value="ekal"
                        {...register("business_type", { required: false })}
                      />
                    </div>
                    <div className="border-primary-blue  bg-primary-red flex items-center justify-center rounded-full border-l px-1 text-white">
                      <label htmlFor="bahul" > साझेदारी ब्यवसाय </label>
                      <input
                        type="radio"
                        name="radio-btn"
                        id="bahul"
                        value="bahul"
                        {...register("business_type", { required: false })}
                      />
                    </div>
                    <div className="border-primary-blue bg-primary-red flex items-center justify-center rounded-full border-l px-1 text-white">
                      <label htmlFor="prali"> प्रा.लि. कम्पनी </label>
                      <input
                        type="radio"
                        name="radio-btn"
                        id="prali"
                        value="prali"
                        {...register("business_type", { required: false })}
                      />
                    </div>

                  </div>

                  <div className="border-primary-blue  p-3 flex text-primary-red  gap-2 text-base font-bold sm:text-lg">
                    <p>ब्यवसायको प्रकृती : </p>
                    <div className="border-primary-blue px-2 bg-primary-red ml-2 flex items-center justify-center gap-1 text-sm rounded-full border  text-white">
                      <label htmlFor="trading">ट्रेडिङ  </label>
                      <input
                        type="radio"
                        name="radio-btn"
                        id="trading"
                        value="trading"
                        {...register("business_nature", { required: false })}
                      />
                    </div>
                    <div className="border-primary-blue bg-primary-red text-sm flex items-center justify-center rounded-full border-l p-1 text-white">
                      <label htmlFor="industry"> औधोगिक</label>
                      <input
                        type="radio"
                        name="radio-btn"
                        value="industrial"
                        id="industry"
                        {...register("business_nature", { required: false })}
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>


            {/* share holder details form */}
            <div className="mt-5">
              <div className="flex flex-col">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 overflow-x-auto sm:px-6 lg:px-8">
                    <table id="tbl_posts" className="border-x-2 border-b-2 font-Laila px-10 border-primary-blue ">
                      <thead className="border-2 border-primary-blue ">
                        <tr>
                          <td className="border-primary-blue text-center py-3 text-primary-red border text-lg font-bold">
                            पद
                          </td>
                          <td className="border-primary-blue text-center text-primary-red border text-base font-bold sm:text-lg">
                            नाम
                          </td>
                          <td className="border-primary-blue text-center text-primary-red border text-base font-bold sm:text-lg">
                            ठेगाना
                          </td>
                          <td className="border-primary-blue text-center text-primary-red border text-base font-bold sm:text-lg">
                            सम्पर्क नं.
                          </td>
                          <td className="border-primary-blue text-center text-center text-primary-red border text-base font-bold sm:text-lg">
                            फोटो
                          </td>
                        </tr>
                      </thead>
                      <tbody id="tbl_posts_body" >
                        <tr id="rec-1" className="border-primary-blue border">
                          <td className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                            अध्यक्षको नाम
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name="name"
                              // onChange={(e)=> setEmployee(prev=> {})}

                              onChange={(e) => {
                                handleChange(0, e);
                              }}
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name="address"
                              onChange={(e) => {
                                handleChange(0, e);
                              }}
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name="phone"
                              onChange={(e) => {
                                handleChange(0, e);
                              }}
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <div className="border-primary-blue flex text-white m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                              {/* <button className=" bg-yellow-500 rounded-xl px-2 ">
                      Upload
                    </button> */}

                              <input
                                className="file:bg-primary-blue file:text-white file:rounded-xl file:border-none  w-[110px] h-auto text-white rounded-xl ml-3 px-2"
                                type="file"
                                name="photo"
                                onChange={(e) => {
                                  handlePhoto(0, e);
                                }}
                              />

                              <button className="bg-primary-green rounded-xl px-2 ">
                                view
                              </button>
                              <button className="bg-primary-red rounded-xl px-2">
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody id="tbl_posts_body">
                        <tr id="rec-1" className="border-primary-blue border">
                          <td className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                            कार्यकारी प्रमुखको नाम
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name="name"
                              onChange={(e) => {
                                handleChange(1, e);
                              }}
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name="address"
                              onChange={(e) => {
                                handleChange(1, e);
                              }}
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <input
                              type="text"
                              name="phone"
                              onChange={(e) => {
                                handleChange(1, e);
                              }}
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </td>
                          <td className="p-0">
                            <div className="border-primary-blue  flex text-white m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                              {/* <button className=" bg-yellow-500 rounded-xl px-2 ">
                      Upload
                    </button> */}
                              <input
                                className="file:bg-primary-blue w-[110px] h-auto file:border-none  file:text-white file:rounded-xl w-fit text-white rounded-xl ml-3 px-2"
                                type="file"
                                name="photo"
                                onChange={(e) => {
                                  handlePhoto(1, e);
                                }}
                              />

                              <button className="bg-primary-green rounded-xl px-2 ">
                                view
                              </button>
                              <button className="bg-primary-red rounded-xl px-2">
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ display: "none" }}>
                      {/* table row add */}
                      <table id="sample_table">
                        <tbody>
                          <tr id="" className="border-primary-blue border">
                            <td className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                              <span className="sn">1</span>
                            </td>
                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                                id=""
                              />
                            </td>

                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                                id=""
                              />
                            </td>

                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                                id=""
                              />
                            </td>
                            <td className="p-0">
                              <input
                                type="file"
                                name=""
                                className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                                id=""
                              />
                            </td>
                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                                id=""
                              />
                            </td>
                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                                id=""
                              />
                            </td>
                            <td className="p-0">
                              <input
                                type="file"
                                name=""
                                className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                                id=""
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            {/* share holder details form close */}

            {/* upload documents open */}
            <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
              2. Upload Documents
              <span className="text-primary-blue underline font-Lailaila mx-2 ">
                (सामाजिक सुरक्षाकोषमा दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु  Upload  गर्नुहोस् ।)
              </span>
            </div>

            <Documents
              documents_data={SSF_upload_details_v2}
              initialState={data}
              setDocument={setDocsOutput}
            />
            {/* upload documents close */}
            <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue underline font-Laila mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>


            <FormBranch register={register} />
            <FormButtom />
            <FormPayment handleSubmit={handleSubmit}
              handleClick={handleClick}
              setUploadProof={setUploadProof}
              dueAmount={dueAmount}
              setPaidAmount={setPaidAmount}
              totalAmount={receivedAmount.amount}

            />
          </form>

        </> : <>
          <SSFRegistrationB />


        </>
      }

    </div>
  );
};

export default SSFRegistrationA;
